import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getRatePlan } from 'modules/settings/api';

export const useQueryRatePlanDetails = (ratePlanId: string | null) => {
  const {
    data: ratePlan,
    isLoading: isLoadingRatePlan,
    isError: isErrorRatePlan,
    refetch,
  } = useQuery([QUERY_KEYS.SETTINGS_RATE_PLAN, ratePlanId], () => getRatePlan(ratePlanId), {
    enabled: !!ratePlanId,
    cacheTime: 0,
  });

  return { ratePlan, isLoadingRatePlan, isErrorRatePlan, refetch };
};
